module.exports = __webpack_public_path__ + "55355b14c1ac63c69793a1563de6d8ea.svg";